import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastDraftsHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts',
)({
  component: JourneysBroadcastDraftsHandoff,
});
